import {
  ButtonComponent,
  DividerComponent,
  TextFieldComponent,
} from "@/components";
import React, { useState } from "react";
import { IMAGES, MOBILE_REGEX, WEB_COLORS } from "@/lib/constants";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";
import { useTranslations } from "next-intl";
import { ArrowForwardRounded } from "@mui/icons-material";
import styles from "../../personal-loan-landing.module.css"
const RightCard = ({
  formik,
  handleFieldChange,
  isError,
  errorMessage,
  resumeJourney,
  handleResumeJourney,
}) => {
  const t = useTranslations("Login");
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack
      px={{ xs: 4 }}
      py={{ xs: 1 }}
      m={{ xs: 1 }}
      gap={1}
      flexGrow={1}
      direction={"column"}
      bgcolor={WEB_COLORS.darkTeal}
      borderRadius={"24px"}
      position={"relative"}
    >
      <Box className={styles["trapezoid-left"]} ></Box>
      <Box className={styles["trapezoid-right"]} ></Box>

      <Grid
        container
        gap={1}
        display={"flex"}
        alignItems={"flex-start"}
        justifyContent={"center"}
      >
        <Typography
          fontWeight={700}
          color={"#fff"}
          fontSize={{ md: "40px", xs: "24px" }}
        >
          Get
        </Typography>
        <Typography
          fontWeight={700}
          color={"#00F200"}
          fontSize={{ md: "40px", xs: "24px" }}
        >
          Started
        </Typography>
      </Grid>
      {isBelowMd ? (
        <Box position="relative" width="100%">
          <TextFieldComponent
            shrink
            type="number"
            name="phone"
            maxLength={10}
            value={formik?.values?.phone}
            placeholder={"Enter your phone number"}
            errorMessage={formik?.errors?.phone}
            error={Boolean(formik?.touched?.phone && formik?.errors?.phone)}
            success={Boolean(formik?.touched?.phone && !formik?.errors?.phone)}
            onBlur={formik.handleBlur}
            onChange={(e) => {
              handleFieldChange(e, MOBILE_REGEX);
            }}
            inputPropsStyle={{ border: "none", color: "#4D6767" }} // space for button
            size="small"
            backgroundColor={"white"}
          />
          <Box position="absolute" top={5} right={8}>
            <ButtonComponent
              toolTipTitle={t("loginttoltip")}
              type="submit"
              onClick={formik.handleSubmit}
              disabled={!(formik.isValid && formik.dirty)}
              size="small"
              buttonStyle={{
                height: "25px",
                backgroundColor: "#00F200",
                color: WEB_COLORS.darkTeal,
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#00F200",
                  color: WEB_COLORS.darkTeal,
                  cursor: "pointer",
                },
                "&:disabled": {
                  backgroundColor: "#407168",
                  color: "#fff",
                },
              }}
            >
              Apply Now
            </ButtonComponent>
          </Box>
        </Box>
      ) : (
        <TextFieldComponent
          shrink
          type="number"
          name="phone"
          maxLength={10}
          value={formik?.values?.phone}
          placeholder={"Enter your phone number"}
          errorMessage={formik?.errors?.phone}
          error={Boolean(formik?.touched?.phone && formik?.errors?.phone)}
          success={Boolean(formik?.touched?.phone && !formik?.errors?.phone)}
          onBlur={formik.handleBlur}
          onChange={(e) => {
            handleFieldChange(e, MOBILE_REGEX);
          }}
          inputPropsStyle={{ color: "#4D6767" }}
          size=""
          backgroundColor={"white"}
        />
      )}

      <Stack width={"100%"}>
        <FormControlLabel
          control={
            <Checkbox
              name="terms"
              checked={formik.values.terms}
              onChange={formik.handleChange}
              sx={{
                color: "white", // color of unchecked box border and checkmark color
                "&.Mui-checked": {
                  color: "white", // color when checked
                },
              }}
            />
          }
          label={
            <Typography color={"#fff"} fontSize={14}>
              {t("termsandconditions")}{" "}
              <a
                className="doc-link"
                href={process.env.NEXT_PUBLIC_TERMS_AND_CONDITIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("terms")}
              </a>{" "}
              {t("and")}{" "}
              <a
                className="doc-link"
                href={process.env.NEXT_PUBLIC_PRIVACY_POLICY_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("privacy")}
              </a>{" "}
              {t("consent")}
            </Typography>
          }
        />

        <FormControlLabel
          control={
            <Checkbox
              name="whatsapp"
              checked={formik.values.whatsapp}
              onChange={formik.handleChange}
              sx={{
                color: "white", // color of unchecked box border and checkmark color
                "&.Mui-checked": {
                  color: "white", // color when checked
                },
              }}
            />
          }
          label={
            <Typography
              color={"#ffffff"}
              fontSize={14}
              sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
            >
              {t("whatsapp")}{" "}
              <Image
                src={IMAGES.whatsApp}
                alt="whatsApp"
                height={25}
                width={25}
              />
            </Typography>
          }
        />
      </Stack>
      {!isBelowMd && (
        <ButtonComponent
          toolTipTitle={t("loginttoltip")}
          type="submit"
          onClick={formik.handleSubmit}
          disabled={!(formik.isValid && formik.dirty)}
          size={`${isBelowMd ? "small" : ""}`}
          buttonStyle={{
            height: "60px",
            backgroundColor: "#00F200",
            color: WEB_COLORS.darkTeal,
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#00F200",
              color: WEB_COLORS.darkTeal,
              cursor: "pointer",
            },
            "&:disabled": {
              backgroundColor: "#407168",
              color: "#fff",
            },
          }}
        >
          Apply Now
        </ButtonComponent>
      )}
      <DividerComponent color={"#fff"} />
      <Typography
        // type="submit"
        textAlign={"center"}
        color={"#fff"}
        onClick={() => handleResumeJourney(!resumeJourney)}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        p={2}
      >
        Resume Your Journey
        <ArrowForwardRounded fontSize="small" />
      </Typography>
    </Stack>
  );
};

export default RightCard;
